export const BasicInfoRules = {
  name: [
    { required: true, message: "请输入用户姓名", trigger: "blur" },
    { min: 1, max: 32, message: "长度在 32 个字符之内", trigger: "blur" }
  ],
  userId: [
    { required: true, message: "请输入用户手机号", trigger: "blur" },
    { min: 1, max: 32, message: "长度在 32 个字符之内", trigger: "blur" }
  ],
  idNumber2: [
    { required: true, message: "请输入证件号码", trigger: "blur" },
    { min: 1, max: 18, message: "长度在 18 个字符之内", trigger: "blur" }
  ],
  idNumber: [
    { required: true, message: "请输入身份证号", trigger: "blur" },
    { min: 18, max: 18, message: "长度为 18 个字符", trigger: "blur" },
    {
      validator(rule, value, callback) {
        // 地区
        var aCity = {
          11: "北京",
          12: "天津",
          13: "河北",
          14: "山西",
          15: "内蒙古",
          21: "辽宁",
          22: "吉林",
          23: "黑龙江",
          31: "上海",
          32: "江苏",
          33: "浙江",
          34: "安徽",
          35: "福建",
          36: "江西",
          37: "山东",
          41: "河南",
          42: "湖北",
          43: "湖南",
          44: "广东",
          45: "广西",
          46: "海南",
          50: "重庆",
          51: "四川",
          52: "贵州",
          53: "云南",
          54: "西藏",
          61: "陕西",
          62: "甘肃",
          63: "青海",
          64: "宁夏",
          65: "新疆",
          71: "台湾",
          81: "香港",
          82: "澳门",
          91: "国外"
        };
        // 验证长度
        if (!/^\d{17}(\d|x)$/i.test(value)) {
          callback(
            new Error("您输入的身份证号长度或格式错误，请输入正确的身份证号")
          );
          return;
        }
        // 验证前两位是否为省份代码
        value = value.replace(/x$/i, "a");
        if (aCity[parseInt(value.substr(0, 2))] == null) {
          callback(
            new Error("您输入的身份证号长度或格式错误，请输入正确的身份证号")
          );
          return;
        }
        // 身份证上的出生年月校验
        var sBirthday =
          value.substr(6, 4) +
          "-" +
          Number(value.substr(10, 2)) +
          "-" +
          Number(value.substr(12, 2));
        var d = new Date(sBirthday.replace(/-/g, "/"));
        if (
          sBirthday !=
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()
        ) {
          callback(new Error("您输入的身份证号不合法，请输入正确的身份证号"));
          return;
        }
        // 身份证校验位判断
        var iSum = 0;
        for (var i = 17; i >= 0; i--) {
          iSum += (Math.pow(2, i) % 11) * parseInt(value.charAt(17 - i), 11);
        }
        if (iSum % 11 != 1) {
          callback(new Error("您输入的身份证号不合法，请输入正确的身份证号"));
          return;
        }
        callback();
      }
    }
  ],
  directionLv2TpCode: [
    { required: true, message: "请选择二级研究方向", trigger: "blur" }
  ],
  directionLv2Desc: [
    { required: true, message: "请输入其他二级方向", trigger: "blur" }
  ],

  telNumLong: [
    { min: 1, max: 11, message: "长度在 11个字符之内", trigger: "blur" }
  ],
  telNumShort: [
    { min: 1, max: 11, message: "长度在 11个字符之内", trigger: "blur" }
  ],
  email: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^[a-z0-9]+([._-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
        if (reg.test(value) || !value) {
          callback();
        } else {
          callback(new Error("请输入合法邮箱地址"));
        }
      }
    }
  ],
  mail: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^[a-z0-9]+([._-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
        if (reg.test(value) || !value) {
          callback();
        } else {
          callback(new Error("请输入合法邮箱地址"));
        }
      }
    }
  ],
  workNumber: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  section: [
    { min: 1, max: 32, message: "长度在 32 个字符之内", trigger: "blur" }
  ],
  currentSectionPosition: [
    { min: 1, max: 50, message: "长度在 50个字符之内", trigger: "blur" }
  ],

  researchDirection: [
    { min: 1, max: 50, message: "长度在 50个字符之内", trigger: "blur" }
  ],
  universitySchool: [
    { min: 1, max: 32, message: "长度在 32 个字符之内", trigger: "blur" }
  ],
  universityMajor: [
    { min: 1, max: 32, message: "长度在 32 个字符之内", trigger: "blur" }
  ],
  undergradSchool: [
    { min: 1, max: 32, message: "长度在 32个字符之内", trigger: "blur" }
  ],
  undergradMajor: [
    { min: 1, max: 32, message: "长度在 32个字符之内", trigger: "blur" }
  ],

  masterSchool: [
    { min: 1, max: 32, message: "长度在 32个字符之内", trigger: "blur" }
  ],
  masterMajor: [
    { min: 1, max: 32, message: "长度在 32个字符之内", trigger: "blur" }
  ],

  masterTutorName: [
    { min: 1, max: 32, message: "长度在 32个字符之内", trigger: "blur" }
  ],
  phdSchool: [
    { min: 1, max: 32, message: "长度在 32个字符之内", trigger: "blur" }
  ],
  phdMajor: [
    { min: 1, max: 32, message: "长度在 32个字符之内", trigger: "blur" }
  ],

  phdTutorName: [
    { min: 1, max: 32, message: "长度在 32个字符之内", trigger: "blur" }
  ],
  postDoctoralSchool: [
    { min: 1, max: 32, message: "长度在 32个字符之内", trigger: "blur" }
  ],
  postDoctoralMajor: [
    { min: 1, max: 32, message: "长度在 32个字符之内", trigger: "blur" }
  ],

  postDoctoralTutorName: [
    { min: 1, max: 32, message: "长度在 32个字符之内", trigger: "blur" }
  ],
  disciplineLevel: [
    { min: 1, max: 32, message: "长度在 32个字符之内", trigger: "blur" }
  ]
};

export const WorkInfoRules = {
  bookName: [
    { required: true, message: "请输入书名", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  isbn: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  academicAdvisor: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  honoraryEditor: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  chiefJudge: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  chiefEditor: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  viceChiefEditor: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  mainEditor: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  execEditorialCommit: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  editorialCommit: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  partEditor: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  contributor: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  writingSecretary: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  publishUnit: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ]
};

export const PatentInfoRules = {
  patentId: [
    { required: true, message: "请输入专利号", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  patentName: [
    { required: true, message: "请输入专利名", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  applicationNo: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  patentCertNo: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  certNo: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  authNoticeNo: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  patentee: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  patentApplicationYear: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  patentApproveProgress: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  authCountry: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  inventorName: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ]
};

export const PaperInfoRules = {
  paperId: [
    { required: true, message: "请输入论文编号", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  paperTitle: [
    { required: true, message: "请输入论文题目", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  paperTypeCode: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  postJournal: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  postPage: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  firstAuthorName: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  firstAuthorSection: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  statSrcJournalInclu: [
    { min: 1, max: 1, message: "仅支持输入一个字符", trigger: "blur" }
  ],
  cnCoreJournalInclu: [
    { min: 1, max: 1, message: "仅支持输入一个字符", trigger: "blur" }
  ],
  normalCnJournalInclu: [
    { min: 1, max: 1, message: "仅支持输入一个字符", trigger: "blur" }
  ],
  sci: [{ min: 1, max: 1, message: "仅支持输入一个字符", trigger: "blur" }],
  ei: [{ min: 1, max: 1, message: "仅支持输入一个字符", trigger: "blur" }],
  normalFrJournalInclu: [
    { min: 1, max: 1, message: "仅支持输入一个字符", trigger: "blur" }
  ],
  cnSeriesJournal: [
    { min: 1, max: 1, message: "仅支持输入一个字符", trigger: "blur" }
  ],
  ssci: [{ min: 1, max: 1, message: "仅支持输入一个字符", trigger: "blur" }],
  istp: [{ min: 1, max: 1, message: "仅支持输入一个字符", trigger: "blur" }],
  ca: [{ min: 1, max: 1, message: "仅支持输入一个字符", trigger: "blur" }],
  ba: [{ min: 1, max: 1, message: "仅支持输入一个字符", trigger: "blur" }],
  em: [{ min: 1, max: 1, message: "仅支持输入一个字符", trigger: "blur" }],
  im: [{ min: 1, max: 1, message: "仅支持输入一个字符", trigger: "blur" }],
  impactFactor: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  corrAuth: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  authList: [
    { min: 1, max: 200, message: "长度在 200 个字符之内", trigger: "blur" }
  ],
  rnk: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  statusCode: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  reimOrAwards: [
    { min: 1, max: 1, message: "仅支持输入一个字符", trigger: "blur" }
  ],
  reimProgress: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  summary: [
    { min: 1, max: 500, message: "长度在 500 个字符之内", trigger: "blur" }
  ],
  corrAuthSection: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ]
};
export const SubjectInfoRules = {
  subjectId: [
    { required: true, message: "请输入课题编号", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  subjectName: [
    { required: true, message: "请输入课题名称", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  subjectLevel: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  subjectCharger: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  taskSource: [
    { min: 1, max: 100, message: "长度在 100 个字符之内", trigger: "blur" }
  ],
  authorList: [
    { min: 1, max: 200, message: "长度在 200 个字符之内", trigger: "blur" }
  ],
  projectNo: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  approvalNo: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  subjectNo: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  remarks: [
    { min: 1, max: 200, message: "长度在 200 个字符之内", trigger: "blur" }
  ]
};
export const HonorInfoRules = {
  honorYear: [
    { required: true, message: "请输入获奖年度", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  honorName: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  honorRank: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  honorUnit: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  otherHonorUnit: [
    { min: 1, max: 200, message: "长度在 200 个字符之内", trigger: "blur" }
  ],
  awardLv: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  certNo: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ]
};
export const TalentInfoRules = {
  prj: [
    { required: true, message: "请输入项目", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  year: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  name: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  unit: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  tp: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  researchPrjName: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  researchPrjTpCode: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ]
};
export const TeacherInfoRules = {
  teacherName: [
    { required: true, message: "请输入名老中医姓名", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  studentName: [
    { required: true, message: "请输入跟师徒弟姓名", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  teacherDesc: [
    { min: 1, max: 200, message: "长度在 200 个字符之内", trigger: "blur" }
  ],
  studentDesc: [
    { min: 1, max: 200, message: "长度在 200 个字符之内", trigger: "blur" }
  ]
};

export const AchiInfoRules = {
  achiId: [
    { required: true, message: "请输入转化编号", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  achiName: [
    { min: 1, max: 100, message: "长度在 100 个字符之内", trigger: "blur" }
  ],
  patentee: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  transferee: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ]
};
export const TeachingInfoRules = {
  name: [
    { required: true, message: "请输入名称", trigger: "blur" },
    { min: 1, max: 200, message: "长度在 200 个字符之内", trigger: "blur" }
  ],
  taskSource: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  lv: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  year: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }]
};
export const GcpInfoRules = {
  name: [
    { required: true, message: "请输入GCP名称", trigger: "blur" },
    { min: 1, max: 200, message: "长度在 200 个字符之内", trigger: "blur" }
  ],
  period: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  princResearcher: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  regCategory: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  prjNature: [
    { min: 1, max: 1, message: "仅支持输入一个字符", trigger: "blur" }
  ],
  researcher: [
    { min: 1, max: 200, message: "长度在 200 个字符之内", trigger: "blur" }
  ],
  qualityController: [
    { min: 1, max: 200, message: "长度在 200 个字符之内", trigger: "blur" }
  ],
  status: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  applicant: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  undertakeSection: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  reviewMode: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  prjNo: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  ethicReviewNo: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ]
};
export const AwardInfoRules = {
  awardId: [
    { required: true, message: "请输入奖励ID", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  year: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  awardName: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  awardCategory: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  awardLevel: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  awardingUnit: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  certNo: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  memberList: [
    { min: 1, max: 200, message: "长度在 200 个字符之内", trigger: "blur" }
  ],
  remark: [
    { min: 1, max: 200, message: "长度在 200 个字符之内", trigger: "blur" }
  ]
};

export const MeetingInfoRules = {
  meetingName: [
    { required: true, message: "请输入会议名称", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  eduProgramName: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  meetingLocation: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  apprUnit: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  organizeUnit: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  coOrganizeUnit: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  prjNo: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  charger: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  tel: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  academicPaper: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  meetingPaper: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  trainingFor: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ]
};
export const StudyInfoRules = {
  title: [
    { required: true, message: "请输入职称", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  workNo: [
    { required: true, message: "请输入工号", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  tel: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  section: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  sectionCategory: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  unit: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  address: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  major: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  year: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  studyScholar: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ]
};

export const GraduateInfoRules = {
  name: [
    { required: true, message: "请输入学生姓名", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 30 个字符之内", trigger: "blur" }
  ],
  degreesCode: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  paper: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  section: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  sourceSchool: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  graduateTo: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  address: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  zipCode: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  tel: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  email: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  wechat: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  direction: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  specialty: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  paperNo: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ]
};
export const LectureInfoRules = {
  year: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  title: [
    { required: true, message: "请输入题目", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 30 个字符之内", trigger: "blur" }
  ],
  name: [
    { required: true, message: "请输入会议名称", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50个字符之内", trigger: "blur" }
  ],
  organizeUnit: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  lectureLocation: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  nature: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  awardLevel: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  peopleNumber: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ]
};
export const StudioInfoRules = {
  unitName: [
    { required: true, message: "请输入扶贫单位名称", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  studioName: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ]
};
export const CenterInfoRules = {
  name: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  unit: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  unitRole: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ]
};
export const Lecture2InfoRules = {
  platform: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  author: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  title: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }]
};

export const AppointmentInfoRules = {
  committee: [
    { required: true, message: "请输入委员会", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50个字符之内", trigger: "blur" }
  ],
  society: [
    { required: true, message: "请输入学会", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50个字符之内", trigger: "blur" }
  ],
  job: [{ min: 1, max: 50, message: "长度在 50个字符之内", trigger: "blur" }],
  societyLv: [
    { min: 1, max: 50, message: "长度在 50个字符之内", trigger: "blur" }
  ],
  isProvideCert: [
    { min: 1, max: 50, message: "长度在 50个字符之内", trigger: "blur" }
  ]
};

export const GuideInfoRules = {
  year: [
    { required: true, message: "请输入年度", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50个字符之内", trigger: "blur" }
  ],
  name: [
    { required: true, message: "请输入名称", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50个字符之内", trigger: "blur" }
  ],
  unit: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  majorDrafter: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ]
};

export const ArticleInfoRules = {
  year: [
    { required: true, message: "请输入年度", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50个字符之内", trigger: "blur" }
  ],
  articleName: [
    { required: true, message: "请输入文章名称", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50个字符之内", trigger: "blur" }
  ],
  platformName: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  author: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ]
};

export const AllianceInfoRules = {
  year: [{ min: 1, max: 50, message: "长度在 50个字符之内", trigger: "blur" }],
  allianceName: [
    { required: true, message: "请输入联盟名称", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 50个字符之内", trigger: "blur" }
  ],
  unitRole: [
    { min: 1, max: 50, message: "长度在 50个字符之内", trigger: "blur" }
  ],
  unit: [{ min: 1, max: 50, message: "长度在 50个字符之内", trigger: "blur" }],
  remarks: [
    { min: 1, max: 200, message: "长度在 200个字符之内", trigger: "blur" }
  ]
};
export const VolunteerInfoRules = {
  title: [
    { required: true, message: "请输入题目", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 30 个字符之内", trigger: "blur" }
  ],
  year: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  section: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  isPoverty: [
    { min: 1, max: 1, message: "仅支持输入一个字符", trigger: "blur" }
  ],
  isPosition: [
    { min: 1, max: 1, message: "仅支持输入一个字符", trigger: "blur" }
  ],
  supportUnit: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  remarks: [
    { min: 1, max: 200, message: "长度在 200 个字符之内", trigger: "blur" }
  ],
  major: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  location: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  reqDepartment: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  address: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  contact: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  contactTel: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  honorName: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ]
};
export const QualityInfoRules = {
  name: [
    { required: true, message: "请输入项目名称", trigger: "blur" },
    { min: 1, max: 50, message: "长度在 30 个字符之内", trigger: "blur" }
  ],
  lv: [{ min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }],
  section: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  charger: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  participant: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  statusCode: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ]
};

export const TrainingInfoRules = {
  trainingType: [
    { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" }
  ],
  trainingContent: [
    { min: 1, max: 200, message: "长度在 200 个字符之内", trigger: "blur" }
  ]
};

export const registerRules1 = {
  phone: [
    {
      validator(rule, value, callback) {
        var amPhone = /^[6]([8|6])\d{5}$/;
        var xgPhone = /^([6|9])\\d{7}$/;
        var twPhone = /^[0][9]\d{8}$/;
        var zgdlPhone = /^1[3-9]\d{9}$/;
        if (!value) {
          return callback(new Error("手机号不能为空"));
        } else if (
          value.length != 7 &&
          value.length != 8 &&
          value.length != 10 &&
          value.length != 11
        ) {
          return callback(new Error("手机号长度不规范"));
        } else if (value.length == 7 && !amPhone.test(value)) {
          return callback(new Error("手机号格式不规范"));
        } else if (value.length == 8 && !xgPhone.test(value)) {
          return callback(new Error("手机号格式不规范"));
        } else if (value.length == 10 && !twPhone.test(value)) {
          return callback(new Error("手机号格式不规范"));
        } else if (value.length == 11 && !zgdlPhone.test(value)) {
          return callback(new Error("手机号格式不规范"));
        } else {
          callback();
        }
      }
    }
  ],
  phoneRegisteCode: [
    {
      validator(rule, value, callback) {
        if (!value) {
          return callback(new Error("验证码不能为空"));
        } else {
          callback();
        }
      }
    }
  ],
  inviteCode: [
    {
      validator(rule, value, callback) {
        if (!value) {
          return callback(new Error("邀请码不能为空"));
        } else {
          callback();
        }
      }
    }
  ],
  password: [
    {
      validator(rule, value, callback) {
        var regex = new RegExp(
          "(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{10,20}"
        );
        if (!value) {
          return callback(new Error("密码不能为空"));
        } else if (value.length < 10 || value.length > 20) {
          return callback(new Error("密码长度为10～20位"));
        } else if (!regex.test(value)) {
          return callback(new Error("密码必需包含数字、大小写字母和字符"));
        } else {
          callback();
        }
      }
    }
  ],

  //与上面的password的校验规则一致
  newPwd: [
    {
      validator(rule, value, callback) {
        var regex = new RegExp(
          "(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{10,20}"
        );
        if (!value) {
          return callback(new Error("密码不能为空"));
        } else if (value.length < 10 || value.length > 20) {
          return callback(new Error("密码长度为10～20位"));
        } else if (!regex.test(value)) {
          return callback(new Error("密码必需包含数字、大小写字母和字符"));
        } else {
          callback();
        }
      }
    }
  ],

  confirmPassword: [
    {
      validator(rule, value, callback) {
        if (value === "") {
          callback(new Error("确认密码不能为空"));
        } else if (value !== document.getElementById("password").value) {
          callback(new Error("确认密码与密码不一致"));
        } else {
          callback();
        }
      }
    }
  ],

  confirmNewPwd: [
    {
      validator(rule, value, callback) {
        if (value === "") {
          callback(new Error("确认密码不能为空"));
        } else if (value !== document.getElementById("newPwd").value) {
          callback(new Error("确认密码与密码不一致"));
        } else {
          callback();
        }
      }
    }
  ]
};

export const registerRules2 = {
  userName: [
    {
      validator(rule, value, callback) {
        if (!value) {
          return callback(new Error("姓名不能为空"));
        } else {
          callback();
        }
      }
    }
  ],
  provinceCode: [
    {
      validator(rule, value, callback) {
        if (!value) {
          return callback(new Error("省份市级不能为空"));
        } else {
          callback();
        }
      }
    }
  ],
  departmentName: [
    {
      validator(rule, value, callback) {
        if (!value) {
          return callback(new Error("所属机构不能为空"));
        } else {
          callback();
        }
      }
    }
  ],
  lv2Code: [
    {
      validator(rule, value, callback) {
        if (!value) {
          return callback(new Error("二级研究方向不能为空"));
        } else {
          callback();
        }
      }
    }
  ],
  lv2Desc: [
    {
      validator(rule, value, callback) {
        if (!value) {
          return callback(new Error("二级研究方向(其他)不能为空"));
        } else {
          callback();
        }
      }
    }
  ]
};

export const uCenterPwdRule = {
  oldPwd: [
    { required: true, message: "请输入旧密码", trigger: "blur" },
    { min: 1, max: 64, message: "长度在 64个字符之内", trigger: "blur" }
  ],
  newPwd: [
    { required: true, message: "请输入新密码", trigger: "blur" },
    { min: 1, max: 64, message: "长度在 64个字符之内", trigger: "blur" }
  ],
  confirmNewPwd: [
    { required: true, message: "请输入确认密码", trigger: "blur" },
    { min: 1, max: 64, message: "长度在 64个字符之内", trigger: "blur" }
  ]
};
export const CaseShareRules = {
  title: [
    { required: true, message: "请输入标题", trigger: "blur" },
    { min: 1, max: 64, message: "长度在 50个字符之内", trigger: "blur" }
  ]
};
export const LoudSpeakerRules = {
  postTitle: [
    { required: true, message: "请输入标题", trigger: "blur" },
    { min: 1, max: 64, message: "长度在 50个字符之内", trigger: "blur" }
  ],
  postContent: [
    { required: true, message: "请输入内容", trigger: "blur" },
    { min: 1, max: 1000, message: "长度在 1000 个字符之内", trigger: "blur" }
  ]
};
export const TriangleListRules = {
  postTitle: [
    { required: true, message: "请输入标题", trigger: "blur" },
    { min: 1, max: 64, message: "长度在 50个字符之内", trigger: "blur" }
  ],
  postContent: [
    { required: true, message: "请输入内容", trigger: "blur" },
    { min: 1, max: 1000, message: "长度在 1000 个字符之内", trigger: "blur" }
  ]
};
export const ArticleRules = {
  title: [
    { required: true, message: "请输入标题", trigger: "blur" },
    { min: 1, max: 64, message: "长度在 50个字符之内", trigger: "blur" }
  ]
};

export const Learning2Rules = {
  school: [
    { required: true, message: "请输入毕业学校", trigger: "blur" },
    { min: 1, max: 50, message: "长度在50个字符之内", trigger: "blur" }
  ],
  beginDate: [{ required: true, message: "请选择入学时间", trigger: "blur" }],
  endDate: [{ required: true, message: "请选择毕业时间", trigger: "blur" }],
  educationCode: [{ required: true, message: "请选择学历", trigger: "change" }],
  degreeCode: [{ required: true, message: "请选择学位", trigger: "blur" }],
  majorName: [
    { min: 1, max: 50, message: "长度在50个字符之内", trigger: "blur" }
  ],
  teacher: [{ min: 1, max: 50, message: "长度在50个字符之内", trigger: "blur" }]
};

export const StudyRules = {
  unitName: [
    { required: true, message: "请输入进修单位及部门", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  begDate: [{ required: true, message: "请选择开始时间", trigger: "blur" }],
  endDate: [{ required: true, message: "请选择结束时间", trigger: "blur" }],
  majorName: [
    { required: true, message: "请输入专业", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ]
};

export const AbroadRules = {
  areaName: [
    { required: true, message: "请输入研修国家或地区", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  organizationName: [
    { required: true, message: "请输入研修机构", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  begDate: [{ required: true, message: "请选择开始时间", trigger: "blur" }],
  endDate: [{ required: true, message: "请选择结束时间", trigger: "blur" }],
  majorName: [
    { required: true, message: "请输入研修专业", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ]
};

export const TeacherRules = {
  teacherName: [
    { required: true, message: "请输入跟师导师姓名", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  organizationName: [
    { required: true, message: "请输入跟师单位及部门", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  begDate: [{ required: true, message: "请选择开始时间", trigger: "blur" }],
  endDate: [{ required: true, message: "请选择结束时间", trigger: "blur" }],
  majorName: [
    { required: true, message: "请输入跟师专业", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ]
};

export const WorkingRules = {
  unitName: [
    { required: true, message: "请输入工作单位", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  beginDate: [{ required: true, message: "请选择开始时间", trigger: "blur" }],
  endDate: [{ required: true, message: "请选择结束时间", trigger: "blur" }],
  departmentName: [
    { required: true, message: "请输入工作部门", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  job: [
    { required: true, message: "请输入岗位", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ]
};

export const JobRules = {
  jobTpCode: [{ required: true, message: "请选择职称", trigger: "blur" }],
  obtainDate: [{ required: true, message: "请选择取得时间", trigger: "blur" }],
  certNumber: [
    { required: true, message: "请输入证书号码", trigger: "blur" },
    { min: 1, max: 50, message: "长度在50个字符之内", trigger: "blur" }
  ]
};

export const YSCRules = {
  majorTpCode: [{ required: true, message: "请选择专业", trigger: "blur" }],
  typeTpCode: [{ required: true, message: "请选择类别", trigger: "change" }],
  obtainDate: [{ required: true, message: "请选择取得时间", trigger: "blur" }],
  certNumber: [
    { required: true, message: "请输入证书号码", trigger: "blur" },
    { min: 1, max: 50, message: "长度在50个字符之内", trigger: "blur" }
  ]
};

export const YSMRules = {
  majorTpCode: [
    { required: true, message: "请选择执业范围", trigger: "change" }
  ],
  typeTpCode: [
    { required: true, message: "请选择执业类别", trigger: "change" }
  ],
  obtainDate: [{ required: true, message: "请选择取得时间", trigger: "blur" }],
  certNumber: [
    { required: true, message: "请输入证书号码", trigger: "blur" },
    { min: 1, max: 50, message: "长度在50个字符之内", trigger: "blur" }
  ]
};

export const JSCRules = {
  obtainDate: [{ required: true, message: "请选择取得时间", trigger: "blur" }],
  certNumber: [
    { required: true, message: "请输入证书号码", trigger: "blur" },
    { min: 1, max: 50, message: "长度在50个字符之内", trigger: "blur" }
  ]
};

export const PaperRules = {
  title: [
    { required: true, message: "请输入论文标题", trigger: "blur" },
    { min: 1, max: 50, message: "长度在50个字符之内", trigger: "blur" }
  ],
  natureTpCode: [
    { required: true, message: "请选择论文性质代码", trigger: "change" }
  ],
  direction: [
    { required: true, message: "请输入研究方向", trigger: "blur" },
    { min: 1, max: 50, message: "长度在50个字符之内", trigger: "blur" }
  ],
  journal: [
    { required: true, message: "发表期刊", trigger: "blur" },
    { min: 1, max: 50, message: "长度在50个字符之内", trigger: "blur" }
  ],
  publishDate: [{ required: true, message: "请选择发表日期", trigger: "blur" }],
  page: [
    { required: true, message: "请输入年卷期页", trigger: "blur" },
    { min: 1, max: 50, message: "长度在50个字符之内", trigger: "blur" }
  ],
  factor: [
    { required: true, message: "请输入影响因子", trigger: "blur" },
    { min: 1, max: 50, message: "长度在50个字符之内", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(\d+(\.\d{1,})$|(^[1-9]\d*$))|(0)$/;
        if (reg.test(value) || !value) {
          callback();
        } else {
          callback(new Error("请输入正确的影响因子"));
        }
      }
    }
  ],
  partitions: [
    { required: true, message: "请输入中科院JCR分区", trigger: "blur" },
    { min: 1, max: 50, message: "长度在50个字符之内", trigger: "blur" }
  ],
  authors: [
    { required: true, message: "请输入作者列表", trigger: "blur" },
    { min: 1, max: 500, message: "长度在500个字符之内", trigger: "blur" }
    // {
    //   validator(rule, value, callback) {
    //     const reg = /^[\u4E00-\u9FA5A-Za-z0-9,，·]+$/;
    // if (reg.test(value) || !value) {
    // if (!value) {
    //   callback();
    // }
    // else{
    //   callback(new Error("名字之间请用逗号隔开"));
    // }
    // }
    // }
  ],
  correspondingAuthorUnit: [
    // {required: true,message: '请输入通讯作者单位', trigger: 'blur'},
    { min: 1, max: 500, message: "长度在500个字符之内", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^[\u4E00-\u9FA5A-Za-z0-9,，·]+$/;
        if (reg.test(value) || !value) {
          callback();
        } else {
          callback(new Error("单位之间之间请用逗号隔开"));
        }
      }
    }
  ],
  score: [
    { required: true, message: "请输入评分", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 10000) {
            callback(new Error("请小于10000"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的分数"));
        }
      }
    }
  ]
};

export const KetiRules = {
  title: [
    { required: true, message: "请输入课题名称", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  ktTpCode: [{ required: true, message: "请选择类别", trigger: "blur" }],
  ktLvTpCode: [
    { required: true, message: "请选择课题级别", trigger: "change" }
  ],
  ktRank: [
    {
      validator(rule, value, callback) {
        const reg = /^[1-9]\d*$/;
        if (reg.test(value) || !value) {
          if (value && value.length > 5) {
            callback(new Error("不能高于100000名"));
          } else callback();
        } else {
          callback(new Error("请输入正确排名"));
        }
      }
    }
  ],
  beginDate: [{ required: true, message: "请选择开始日期", trigger: "blur" }],
  endDate: [{ required: true, message: "请选择结束日期", trigger: "blur" }],
  prjNo: [
    { required: true, message: "请输入项目编号", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  funding: [
    { required: true, message: "请输入项目经费", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|0+(.[0-9]{1,4})?|([1-9][0-9]*)+(.[0-9]{1,4})?)$/;
        if (!reg.test(value) || value) {
          callback();
        } else {
          callback(new Error("最多允许4位小数的数值类型"));
        }
      }
    },
    {
      validator(rule, value, callback) {
        if (Number(value) <= 10000000000) {
          callback();
        } else {
          callback(new Error("输入金额过大！"));
        }
      }
    }
  ],
  score: [
    { required: true, message: "请输入评分", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 10000) {
            callback(new Error("请小于10000"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的分数"));
        }
      }
    }
  ]
};

export const GCPRules = {
  title: [
    { required: true, message: "请输入GCP项目", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  term: [
    { required: true, message: "请输入期别", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  regTpCode: [{ required: true, message: "请选择注册分类", trigger: "change" }],
  rankTpCode: [{ required: true, message: "请选择本人排名", trigger: "blur" }],
  natureTpCode: [
    { required: true, message: "请选择项目性质", trigger: "blur" }
  ],
  finishCount: [
    {
      validator(rule, value, callback) {
        const reg = /^[1-9]\d*$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 2147483647) {
            callback(new Error("请小于2,147,483,647"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确排名"));
        }
      }
    }
  ],
  beginDate: [{ required: true, message: "请选择开始日期", trigger: "blur" }],
  endDate: [{ required: true, message: "请选择结束日期", trigger: "blur" }]
};

export const ZhuzuoRules = {
  title: [
    { required: true, message: "请输入书目", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  unit: [
    { required: true, message: "请输入出版单位", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  jobTpCode: [{ required: true, message: "请选择担任职务", trigger: "change" }],
  zhuzuoTpCode: [{ required: true, message: "请选择类型", trigger: "change" }],
  publisherTpCode: [
    { required: true, message: "请选择出版社", trigger: "blur" }
  ],
  beginDate: [{ required: true, message: "请选择出版日期", trigger: "blur" }],
  wordCount: [
    { required: true, message: "请输入字数", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^[1-9]\d*$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 2147483647) {
            callback(new Error("请小于2,147,483,647"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确字数"));
        }
      }
    }
  ],
  score: [
    { required: true, message: "请输入评分", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 10000) {
            callback(new Error("请小于10000"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的分数"));
        }
      }
    }
  ]
};

export const ZhuanliRules = {
  title: [
    { required: true, message: "请输入专利名称", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  zhuanliTpCode: [
    { required: true, message: "请选择专利类别", trigger: "change" }
  ],
  beginDate: [
    { required: true, message: "请选择申请/授权公告日期", trigger: "blur" }
  ],
  isTransfer: [
    { required: true, message: "请选择是否转让", trigger: "change" }
  ],
  transferMoney: [
    { required: true, message: "请输入转让金额", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^\d+(\.\d{1,})$|(^[1-9]\d*$)/;
        if (reg.test(value) || !value) {
          if (Number(value) > 2147483647) {
            callback(new Error("请小于2,147,483,647"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确金额"));
        }
      }
    }
  ],
  ownRank: [
    {
      validator(rule, value, callback) {
        const reg = /^[1-9]\d*$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 2147483647) {
            callback(new Error("请小于2,147,483,647"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确排名"));
        }
      }
    }
  ],
  score: [
    { required: true, message: "请输入评分", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 10000) {
            callback(new Error("请小于10000"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的分数"));
        }
      }
    }
  ]
};

export const HuojiangRules = {
  title: [
    { required: true, message: "请输入获奖名称", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  prjTitle: [
    { required: true, message: "请输入项目名称", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  prjLevelTpCode: [
    { required: true, message: "请选择项目等级", trigger: "change" }
  ],
  huojiangTpCode: [
    { required: true, message: "请选择注册分类", trigger: "change" }
  ],
  levelTpCode: [
    { required: true, message: "请选择项目性质", trigger: "change" }
  ],
  ownRank: [
    {
      validator(rule, value, callback) {
        const reg = /^[1-9]\d*$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 2147483647) {
            callback(new Error("请小于2,147,483,647"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确排名"));
        }
      }
    }
  ],
  beginDate: [{ required: true, message: "请选择获得日期", trigger: "blur" }],
  unitName: [
    { required: true, message: "请输入授予单位", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  score: [
    { required: true, message: "请输入评分", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 10000) {
            callback(new Error("请小于10000"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的分数"));
        }
      }
    }
  ]
};

export const DaijiaoRules = {
  natureTpCode: [
    { required: true, message: "请选择带教性质", trigger: "change" }
  ],
  stuNatureCodes: [
    { required: true, message: "请选择人员性质", trigger: "change" }
  ],
  stuCount: [
    { required: true, message: "请输入参与学生人数", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^[1-9]\d*$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 2147483647) {
            callback(new Error("请小于2,147,483,647"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确人数"));
        }
      }
    }
  ],
  beginDate: [{ required: true, message: "请选择获得时间", trigger: "blur" }],
  score: [
    { required: true, message: "请输入评分", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 10000) {
            callback(new Error("请小于10000"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的分数"));
        }
      }
    }
  ]
};

export const DaoshiRules = {
  // teacherTpCode: [
  //   {required: true,message: '请选择导师类型', trigger: 'blur'},
  // ],
  stuTpCode: [{ required: true, message: "请选择学生类型", trigger: "change" }],
  stuName: [
    { required: true, message: "请填写学生名字", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  stuSourceTpCode: [
    { required: true, message: "请选择学生来源", trigger: "change" }
  ],
  beginDate: [{ required: true, message: "请选择入学时间", trigger: "blur" }],
  endDate: [{ required: true, message: "请选择毕业时间", trigger: "blur" }],
  score: [
    { required: true, message: "请输入评分", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 10000) {
            callback(new Error("请小于10000"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的分数"));
        }
      }
    }
  ]
};

export const ShoushuRules = {
  title: [
    { required: true, message: "请输入手术名称", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  levelTpCode: [{ required: true, message: "请选择级别", trigger: "change" }],
  roleTpCode: [{ required: true, message: "请选择角色", trigger: "change" }],
  shoushuCount: [
    { required: true, message: "请输入数量", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^[1-9]\d*$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 2147483647) {
            callback(new Error("请小于2,147,483,647"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确数量"));
        }
      }
    }
  ],
  allDate: [{ required: true, message: "请选择时间段", trigger: "blur" }],
  score: [
    { required: true, message: "请输入评分", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 10000) {
            callback(new Error("请小于10000"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的分数"));
        }
      }
    }
  ]
};

export const LinchuangRules = {
  title: [
    { required: true, message: "请输入技术名称", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  levelTpCode: [
    { required: true, message: "请选择级别性质", trigger: "change" }
  ],
  bAndEDate: [{ required: true, message: "请选择时间段", trigger: "blur" }],
  ownRank: [
    {
      validator(rule, value, callback) {
        const reg = /^[1-9]\d*$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 2147483647) {
            callback(new Error("请小于2,147,483,647"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确排名"));
        }
      }
    }
  ],
  score: [
    { required: true, message: "请输入评分", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 10000) {
            callback(new Error("请小于10000"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的分数"));
        }
      }
    }
  ]
};

export const ShouzhiRules = {
  shouzhiCount: [
    { required: true, message: "请输入数量", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^[1-9]\d*$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 2147483647) {
            callback(new Error("请小于2,147,483,647"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确数量"));
        }
      }
    }
  ],
  allDate: [{ required: true, message: "请选择时间段", trigger: "blur" }]
};

export const MenzhenRules = {
  shouzhiCount: [
    { required: true, message: "请输入数量", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^[1-9]\d*$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 2147483647) {
            callback(new Error("请小于2,147,483,647"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确数量"));
        }
      }
    }
  ],
  allDate: [{ required: true, message: "请选择时间段", trigger: "blur" }]
};

export const ShehuirenzhiRules = {
  societyLvTpCode: [
    { required: true, message: "请选择学会级别", trigger: "change" }
  ],
  societyTitle: [
    { required: true, message: "请填写学会（分会）", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  jobTpCode: [{ required: true, message: "请选择任职", trigger: "change" }],
  beginDate: [
    { required: true, message: "请选择聘任起始时间", trigger: "blur" }
  ],
  endDate: [{ required: true, message: "请选择聘任截至时间", trigger: "blur" }],
  score: [
    { required: true, message: "请输入评分", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 10000) {
            callback(new Error("请小于10000"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的分数"));
        }
      }
    }
  ]
};

export const YizhenRules = {
  title: [
    { required: true, message: "请输入活动名称", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  addr: [
    { required: true, message: "请输入活动地址", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  unitName: [
    { required: true, message: "请输入举办单位", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  typeTpCode: [{ required: true, message: "请选择类别", trigger: "change" }],
  beginDate: [{ required: true, message: "请选择活动时间", trigger: "blur" }],
  zhuanjiaCount: [
    { required: true, message: '请输入数量(没有输"0")', trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 2147483647) {
            callback(new Error("请小于2,147,483,647"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的数量"));
        }
      }
    }
  ],
  shouzhongCount: [
    { required: true, message: '请输入数量(没有输"0")', trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 2147483647) {
            callback(new Error("请小于2,147,483,647"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的数量"));
        }
      }
    }
  ],
  score: [
    { required: true, message: "请输入评分", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 10000) {
            callback(new Error("请小于10000"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的分数"));
        }
      }
    }
  ]
};

export const KepuRules = {
  prjTitle: [
    { required: true, message: "请输入题目", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  publishTpCode: [
    { required: true, message: "请选择发布形式", trigger: "change" }
  ],
  platformTpCode: [
    { required: true, message: "请选择发布平台", trigger: "change" }
  ],
  levelTpCode: [{ required: true, message: "请选择级别", trigger: "change" }],
  title: [
    { required: true, message: "请输入活动名称", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  beginDate: [{ required: true, message: "请选择发布时间", trigger: "blur" }],
  readedCount: [
    { required: true, message: '请输入数量(没有输"0")', trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 2147483647) {
            callback(new Error("请小于2,147,483,647"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的数量"));
        }
      }
    }
  ],
  zhuanjiaCount: [
    { required: true, message: '请输入数量(没有输"0")', trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 2147483647) {
            callback(new Error("请小于2,147,483,647"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的数量"));
        }
      }
    }
  ],
  shouzhongCount: [
    { required: true, message: '请输入数量(没有输"0")', trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 2147483647) {
            callback(new Error("请小于2,147,483,647"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的数量"));
        }
      }
    }
  ],
  score: [
    { required: true, message: "请输入评分", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 10000) {
            callback(new Error("请小于10000"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的分数"));
        }
      }
    }
  ]
};

export const XueshuRules = {
  title: [
    { required: true, message: "请输入学术会议/学习班名字", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  addr: [
    { required: true, message: "请输入地点/平台", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  unitName: [
    { required: true, message: "请输入举办单位", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  lectureTopic: [
    { required: true, message: "请输入主讲题目", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  typeTpCode: [{ required: true, message: "请选择类别", trigger: "change" }],
  attendTpCode: [
    { required: true, message: "请选择参会性质", trigger: "change" }
  ],
  levelTpCode: [{ required: true, message: "请选择级别", trigger: "change" }],
  beginDate: [{ required: true, message: "请选择时间", trigger: "blur" }],
  score: [
    { required: true, message: "请输入评分", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 10000) {
            callback(new Error("请小于10000"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的分数"));
        }
      }
    }
  ]
};

export const HuizhenRules = {
  inviteUnit: [
    { required: true, message: "请输入会诊邀请单位", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  patientDesc: [
    {
      required: true,
      message: "请输入会诊患者简介（姓名、性别、诊断、诊疗内容等）",
      trigger: "blur"
    },
    { min: 1, max: 600, message: "长度在600个字符之内", trigger: "blur" }
  ],
  beginDate: [{ required: true, message: "请选择会诊日期", trigger: "blur" }],
  score: [
    { required: true, message: "请输入评分", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 10000) {
            callback(new Error("请小于10000"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的分数"));
        }
      }
    }
  ]
};

export const MingyiRules = {
  beginDate: [{ required: true, message: "请选择成立时间", trigger: "blur" }],
  helpUnit: [
    { required: true, message: "请输入帮扶单位名称", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  listingStudio: [
    { required: true, message: "请输入挂牌工作室名称", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ]
};

export const RongyuRules = {
  honoraryTitle: [
    { required: true, message: "请输入荣誉称号名称", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  grantUnit: [
    { required: true, message: "请输入组织/颁奖单位", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  levelTpCode: [
    { required: true, message: "请选择奖励级别", trigger: "change" }
  ],
  beginDate: [{ required: true, message: "请选择获奖时间", trigger: "blur" }],
  ownRank: [
    {
      validator(rule, value, callback) {
        const reg = /^[1-9]\d*$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 2147483647) {
            callback(new Error("请小于2,147,483,647"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确排名"));
        }
      }
    }
  ],
  honoraryTpCode: [{ required: true, message: "请选择类型", trigger: "change" }]
};

export const DangjianRules = {
  beginDate: [
    { required: true, message: "请选择组织或参加活动的时间", trigger: "blur" }
  ],
  addr: [
    { required: true, message: "请输入地点", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  title: [
    { required: true, message: "请输入名称", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  unitName: [
    { required: true, message: "请输入举办单位", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  summary: [
    { required: true, message: "请输入纪要", trigger: "blur" },
    { min: 1, max: 600, message: "长度在600个字符之内", trigger: "blur" }
  ]
};

export const JiansheRules = {
  title: [
    { required: true, message: "请输入标准/指南/共识名称", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  jiansheNo: [
    { required: true, message: "请输入标准/指南/共识号", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  organizationName: [
    { required: true, message: "请输入发布部门/组织", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  typeTpCode: [{ required: true, message: "请选择性质", trigger: "blur" }],
  levelTpCode: [{ required: true, message: "请选择级别", trigger: "change" }],
  beginDate: [{ required: true, message: "请选择发布时间", trigger: "blur" }],
  endDate: [{ required: true, message: "请选择实施时间", trigger: "blur" }],
  ownRank: [
    {
      validator(rule, value, callback) {
        const reg = /^[1-9]\d*$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 2147483647) {
            callback(new Error("请小于2,147,483,647"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确排名"));
        }
      }
    }
  ],
  score: [
    { required: true, message: "请输入评分", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^(0|([1-9])[0-9]*)$/;
        if (reg.test(value) || !value) {
          if (Number(value) > 10000) {
            callback(new Error("请小于10000"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正确的分数"));
        }
      }
    }
  ]
};

export const ZhuankeRules = {
  title: [
    { required: true, message: "请输入名称", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  beginDate: [{ required: true, message: "请选择获得时间", trigger: "blur" }],
  typeTpCode: [{ required: true, message: "请选择单位性质", trigger: "blur" }]
};

export const DuikouRules = {
  title: [
    { required: true, message: "请输入支援单位名称", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  beginDate: [{ required: true, message: "请选择开始时间", trigger: "blur" }],
  endDate: [{ required: true, message: "请选择结束时间", trigger: "blur" }],
  typeTpCode: [
    { required: true, message: "请选择支援性质", trigger: "change" }
  ],
  job: [
    { required: true, message: "请输入任职岗位或职务", trigger: "blur" },
    { min: 1, max: 60, message: "长度在60个字符之内", trigger: "blur" }
  ],
  frequencyTpCode: [
    { required: true, message: "请选择频率值", trigger: "change" }
  ],
  frequencyNumber: [
    { required: true, message: "请输入频率次数", trigger: "blur" },
    {
      validator(rule, value, callback) {
        const reg = /^([1-9]\d*)$/;
        if (reg.test(value) || !value) {
          let frequencyTpCode = document.getElementById("frequencyTpCode")
            ? document.getElementById("frequencyTpCode").value
            : "";
          if (frequencyTpCode == "每周" || frequencyTpCode == "隔周") {
            if (Number(value) > 7) {
              callback(new Error("请小于8"));
              return;
            }
          } else if (frequencyTpCode == "每月" || frequencyTpCode == "隔月") {
            if (Number(value) > 32) {
              callback(new Error("请小于32"));
              return;
            }
          } else if (frequencyTpCode == "每年") {
            if (Number(value) > 366) {
              callback(new Error("请小于367"));
              return;
            }
          }
          callback();
        } else {
          callback(new Error("请输入正确次数"));
        }
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/constants/constantRules.js